import * as THREE from "three";
import {getLAT} from "../LAT/LAT_main";

let activeEffect = null, blockedDueAnimation = false;

const lookAtTime = 600,
    starWarpAutoToggleTime = 5000;

export function disableStarWarp(scene, forceDirectStop, lookAtAfter){
    if(activeEffect === null || blockedDueAnimation) return;
    blockedDueAnimation = true;

    const disableAnimation = ()=>{
        scene.remove(activeEffect);
        activeEffect.parent.remove(activeEffect)
        blockedDueAnimation = false;
        activeEffect = null;
    }

    const look = ()=> {
        if(lookAtAfter){
            getLAT().lookAtObject(lookAtAfter, false, 1000)
        }
    }

    if(forceDirectStop){
        getLAT().replaceSkybox();
        disableAnimation();
        look();
    }
    else{
        setTimeout(disableAnimation, 600)
        setTimeout( ()=> getLAT().replaceSkybox(), 600)
        setTimeout(look, 0)
    }
}

export function toggleStarWarp(scene, disableCallback){
    return activeEffect !== null ? disableStarWarp(scene) : createStarWarp(scene, disableCallback)
}

export function createStarWarp(scene, disableCallback) {

    if(activeEffect !== null || blockedDueAnimation) return;

    const currentLookAt = getLAT().getPointOnSphere();
    getLAT().lookAtObject(new THREE.Vector3(5000, -500, 0), false, lookAtTime);


    let LINE_COUNT = 200000;
    let geom = new THREE.BufferGeometry();
    geom.addAttribute("position", new THREE.BufferAttribute(new Float32Array(6*LINE_COUNT), 3));
    geom.addAttribute("velocity", new THREE.BufferAttribute(new Float32Array(2*LINE_COUNT), 1));
    let geomPosition = geom.getAttribute("position");
    let positions = geomPosition.array;
    let geomVelocity = geom.getAttribute("velocity");
    let velocities = geomVelocity.array;

    let mat = new THREE.LineBasicMaterial({color: 0xffffff});
    let lines = new THREE.LineSegments(geom, mat);
    lines.raycast = ()=> {}; //ignored raycast
    scene.add(lines);
    activeEffect = lines;

    function init(){
        for (let line_index= 0; line_index < LINE_COUNT; line_index++) {
            var x = Math.random() * 400 - 200;
            var y = Math.random() * 200 - 100;
            var z = Math.random() * 500 - 100;
            var xx = x;
            var yy = y;
            var zz = z;
            //line start
            positions[6*line_index] = x;
            positions[6*line_index+1] = y;
            positions[6*line_index+2] = z;
            //line end
            positions[6*line_index+3] = xx;
            positions[6*line_index+4] = yy;
            positions[6*line_index+5] = zz;

            velocities[2*line_index] = velocities[2*line_index+1]= 0;
        }

        getLAT().replaceSkybox({
            "image": 'spacebox'
        })

        setTimeout(()=> {
            disableStarWarp(scene, false, currentLookAt);
            if(disableCallback){
                disableCallback();
            }
        }, starWarpAutoToggleTime);
    }

    function animate() {

        if(activeEffect === null) return;

        const moveIndexes = [0, 3];

        for (let line_index= 0; line_index < LINE_COUNT; line_index++) {
            velocities[2*line_index] += 0.03; //bump up the velocity by the acceleration amount
            velocities[2*line_index+1] += 0.025;

            moveIndexes.forEach((off, offIdx) => {

                positions[6*line_index + off]+= velocities[2*line_index + offIdx];

                if(positions[6*line_index + off] > 200) {
                    const rand= Math.random() * 200 - 100;

                    moveIndexes.forEach(moveIdx => {
                        positions[6*line_index+moveIdx] = rand;
                    })

                    velocities[2*line_index] = 0;
                    velocities[2*line_index+1] = 0;
                }
            })

        }
        geomPosition.needsUpdate = true;
        requestAnimationFrame(animate);
    }

    init();
    animate();
}